import { getValidToken } from '../utils/tokenUtils';

const BASE = '/api/admin/question-sections';

export const fetchQuestionSections = async () => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte hämta sektioner: ${res.status}`);
  return res.json();
};

export const fetchSectionsByContract = async (contractId) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/by-contract/${contractId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte hämta sektioner för kontraktet: ${res.status}`);
  return res.json();
};

export const createQuestionSection = async (payload) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Kunde inte skapa sektion: ${res.status}`);
  return res.json();
};

export const addQuestion = async (sectionId, payload) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/questions`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Kunde inte lägga till fråga: ${res.status}`);
  return res.json();
};

export const linkSectionToContract = async (sectionId, contractId) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/contracts/${contractId}/link`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte länka sektion: ${res.status}`);
};

export const unlinkSectionFromContract = async (sectionId, contractId) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/contracts/${contractId}/unlink`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte ta bort koppling: ${res.status}`);
};

export const updateQuestionSection = async (sectionId, payload) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Kunde inte uppdatera sektion: ${res.status}`);
  return res.json();
};

export const deleteQuestionSection = async (sectionId) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte ta bort sektion: ${res.status}`);
};

export const moveQuestionSection = async (sectionId, direction) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/move?direction=${direction}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte flytta sektion: ${res.status}`);
};

export const updateQuestion = async (sectionId, questionId, payload) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/questions/${questionId}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Kunde inte uppdatera fråga: ${res.status}`);
  return res.json();
};

export const deleteQuestion = async (sectionId, questionId) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/questions/${questionId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte ta bort fråga: ${res.status}`);
};

export const moveQuestion = async (sectionId, questionId, direction) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/sections/${sectionId}/questions/${questionId}/move?direction=${direction}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte flytta fråga: ${res.status}`);
};
